import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { QueryService } from '../../../comun/services/query.service';
import { MascotasComponent } from '../../mascotas.component';
import { FuncionesService } from '../../../comun/services/funciones.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-mascota-fotos',
  templateUrl: './mascota-fotos.component.html',
  styleUrl: './mascota-fotos.component.css',
})
export class MascotaFotosComponent implements OnChanges {
  @Input() mascota: any = {};
  @ViewChild('fileInputFotosMascota') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    public app: MascotasComponent,
    private query: QueryService,
    private funciones: FuncionesService,
    private toastr: ToastrService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mascota'] && this.mascota?.ma_id) {
      this.ordenCambiado = false;
      this.mascota.imagenes = [];
      this.mascota.previewUrl = [];
      const fotos = [...(this.mascota.fotos || [])].sort(
        (a: any, b: any) =>
          Number(a.ft_orden ?? 9999) - Number(b.ft_orden ?? 9999) ||
          (a.ft_principal === 'X' ? -1 : 0) -
            (b.ft_principal === 'X' ? -1 : 0) ||
          Number(a.ft_id) - Number(b.ft_id),
      );
      // Incluir también la foto principal, para poder cambiarla de posición.
      fotos.forEach((foto: any) => {
        this.mascota.imagenes.push({
          data: '',
          url: foto.foto_grande,
          borrada: false,
          ft_id: foto.ft_id,
        });
        this.mascota.previewUrl.push({
          data: '',
          url: foto.foto_thumb,
          borrada: false,
          ft_id: foto.ft_id,
        });
      });
    }
  }

  arrastrando: number | null = null;
  destinoArrastre: number | null = null;
  ordenCambiado = false;
  private punteroActivo: number | null = null;
  private posicionInicial: { x: number; y: number } | null = null;
  private movimientoReal = false;

  // Pointer Events funcionan tanto con ratón como con dedos (incluyendo iOS).
  iniciarArrastrePuntero(event: PointerEvent, indice: number): void {
    if (
      event.button !== 0 ||
      this.mascota.previewUrl[indice]?.borrada ||
      this.punteroActivo !== null
    )
      return;
    this.punteroActivo = event.pointerId;
    this.arrastrando = indice;
    this.destinoArrastre = indice;
    this.posicionInicial = { x: event.clientX, y: event.clientY };
    this.movimientoReal = false;
    (event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
    event.preventDefault();
  }

  moverArrastrePuntero(event: PointerEvent): void {
    if (this.punteroActivo !== event.pointerId || this.arrastrando === null)
      return;
    if (
      this.posicionInicial &&
      Math.hypot(
        event.clientX - this.posicionInicial.x,
        event.clientY - this.posicionInicial.y,
      ) > 5
    ) {
      this.movimientoReal = true;
    }
    if (!this.movimientoReal) return;
    // El elemento mantiene la captura, por ello buscamos qué miniatura queda bajo el dedo.
    const destino = document
      .elementFromPoint(event.clientX, event.clientY)
      ?.closest('[data-foto-indice]');
    const indice = destino
      ? Number(destino.getAttribute('data-foto-indice'))
      : -1;
    this.destinoArrastre =
      Number.isInteger(indice) &&
      indice >= 0 &&
      indice < this.mascota.previewUrl.length &&
      !this.mascota.previewUrl[indice]?.borrada
        ? indice
        : null;
    event.preventDefault();
  }

  soltarArrastrePuntero(event: PointerEvent): void {
    if (this.punteroActivo !== event.pointerId) return;
    // Resolver también el destino en pointerup por si no llegó un último pointermove.
    this.moverArrastrePuntero(event);
    const origen = this.arrastrando;
    const destino = this.destinoArrastre;
    this.limpiarArrastre();
    if (
      origen !== null &&
      destino !== null &&
      origen !== destino &&
      this.movimientoReal
    ) {
      this.reordenarFoto(origen, destino);
    }
    this.movimientoReal = false;
  }

  cancelarArrastrePuntero(event: PointerEvent): void {
    if (this.punteroActivo === event.pointerId) this.limpiarArrastre();
  }

  capturaPerdida(event: PointerEvent): void {
    if (this.punteroActivo === event.pointerId) this.limpiarArrastre();
  }

  private limpiarArrastre(): void {
    this.punteroActivo = null;
    this.arrastrando = null;
    this.destinoArrastre = null;
    this.posicionInicial = null;
  }

  private reordenarFoto(origen: number, destino: number): void {
    if (
      origen < 0 ||
      destino < 0 ||
      origen >= this.mascota.previewUrl.length ||
      destino >= this.mascota.previewUrl.length ||
      this.mascota.previewUrl[origen]?.borrada ||
      this.mascota.previewUrl[destino]?.borrada
    )
      return;
    const [preview] = this.mascota.previewUrl.splice(origen, 1);
    const [imagen] = this.mascota.imagenes.splice(origen, 1);
    this.mascota.previewUrl.splice(destino, 0, preview);
    this.mascota.imagenes.splice(destino, 0, imagen);
    this.ordenCambiado = true;
  }

  moverFoto(indice: number, direccion: number): void {
    const destino = indice + direccion;
    if (
      destino < 0 ||
      destino >= this.mascota.previewUrl.length ||
      this.mascota.previewUrl[indice]?.borrada ||
      this.mascota.previewUrl[destino]?.borrada
    )
      return;
    this.reordenarFoto(indice, destino);
  }

  esPrincipal(indice: number): boolean {
    return (
      !this.mascota.previewUrl[indice]?.borrada &&
      this.mascota.previewUrl.findIndex((foto: any) => !foto.borrada) === indice
    );
  }

  onClickImagen() {
    // Simula el click en el input file
    this.fileInput.nativeElement.click();
  }

  numeroFotosActivas(): number {
    if (!this.mascota.imagenes) {
      return 0;
    }
    return this.mascota.imagenes.filter((img: any) => img.borrada !== true)
      .length;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const LIMITE_MAXIMO = 5;

      // 1. Contar SOLO las fotos que NO están borradas
      const fotosActivas = Number(this.numeroFotosActivas());

      // 2. Validar si ya llegó al límite de activas
      if (fotosActivas >= LIMITE_MAXIMO) {
        this.toastr.error(
          `Ya has alcanzado el límite máximo de ${LIMITE_MAXIMO} fotos activas.`,
        );
        input.value = '';
        return;
      }

      // 3. Calcular cuántas fotos nuevas se permiten
      const fotosPermitidas = LIMITE_MAXIMO - fotosActivas;
      const archivosAProcesar = Array.from(input.files).slice(
        0,
        fotosPermitidas,
      );

      if (input.files.length > fotosPermitidas) {
        this.toastr.warning(
          `Solo se agregaron las primeras ${fotosPermitidas} fotos. El límite de fotos activas es de ${LIMITE_MAXIMO}.`,
        );
      }

      // 4. El punto de inicio para AGREGAR al final del array sigue siendo el length total
      // (así las nuevas se posicionan después de las borradas existentes sin machacarlas)
      const startIndex = this.mascota.imagenes.length;

      archivosAProcesar.forEach((file: File, i: number) => {
        const index = startIndex + i;

        // Reservar posición
        const imagen = { data: '', url: '', borrada: false, ft_id: 0 };
        const preview = { data: '', url: '', borrada: false, ft_id: 0 };
        this.mascota.imagenes[index] = imagen;
        this.mascota.previewUrl[index] = preview;

        // Imagen original
        const readerOriginal = new FileReader();
        readerOriginal.onload = () => {
          if (typeof readerOriginal.result === 'string') {
            imagen.data = readerOriginal.result;
          }
        };
        readerOriginal.readAsDataURL(file);

        // Preview recortado
        this.funciones
          .recortarImagenCuadrada(file, 500)
          .then((dataUrl) => {
            preview.data = dataUrl;
          })
          .catch(console.error);
      });

      input.value = '';
    }
  }

  borrarFoto(indexABorrar: number, temporal: boolean = false) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar esta foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.mascota.imagenes[indexABorrar].borrada = true;
        this.mascota.previewUrl[indexABorrar].borrada = true;
        /*this.mascota.imagenes = this.mascota.imagenes.filter(
          (_: any, index: number) => index !== indexABorrar
        );
        this.mascota.previewUrl = this.mascota.previewUrl.filter(
          (_: any, index: number) => index !== indexABorrar
        );*/
      } else {
      }
    });
  }
}
